import {
  DIVISIONS_LIST_REQUEST,
  DIVISIONS_LIST_SUCCESS,
  DIVISIONS_LIST_FAIL,
} from '../constants/divisionsConstants'

const initialDivisions = [
  {
    id: 'd1',
    title: 'Rx\'d',
    content:
      'Rx\'d group for all age division’s (35-39, 40-44, 45-49, 50-54, 55+) who will complete an Rx’d version of the set workout',
  },
  {
    id: 'd2',
    title: 'Scaled',
    content:
      'Scaled group for all age division’s (35-39, 40-44, 45-49, 50-54, 55+) who will complete a scaled version of the Rx’d workout',
  },
]

export const listDivisions = () => async (dispatch) => {
  try {
    dispatch({ type: DIVISIONS_LIST_REQUEST })

    // const { data } = await axios.get('/api/divisions')

    const data = initialDivisions // temporary

    dispatch({ type: DIVISIONS_LIST_SUCCESS, payload: data })
  } catch (error) {
    dispatch({
      type: DIVISIONS_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
